import { ScrollArea } from '@mantine/core';
import { DOMAINS, DomainKey } from '../../config/domains';
import { MenuRenderer } from '../../layouts/menu/core/MenuRenderer';
import classes from './DomainSidebar.module.css';

/**
 * DomainSidebar Component
 * Displays domain-specific navigation menu
 *
 * Uses the new Menu Domain Contract architecture:
 * - MenuRenderer queries the domain menu provider
 * - Menu structure is defined in domain/providers/{domainKey}Menu.tsx
 * - Supports role/permission-based visibility
 * - Respects menu UI preferences (iconOnly, density, etc.)
 */

interface DomainSidebarProps {
  domainKey: DomainKey;
}

export default function DomainSidebar({ domainKey }: DomainSidebarProps) {
  const domain = DOMAINS[domainKey];

  if (!domain) return null;

  return (
    <ScrollArea
      h="100%"
      type="scroll"
      scrollbarSize={6}
      scrollHideDelay={300}
      classNames={{
        viewport: classes.viewport,
        scrollbar: classes.scrollbar,
        thumb: classes.thumb,
      }}
      styles={{
        root: {
          height: '100%',
        },
      }}
    >
      <MenuRenderer domainId={domainKey} />
    </ScrollArea>
  );
}
